<template>
  <div class="v-map">
    <iframe :src="mapUrl" frameborder="0"></iframe>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { browser } from '@/utils/function'
// eslint-disable-next-line no-unused-vars
function getEid(id) {
  console.log(window)
}
// https://nav.px-bim.com/viewer2/0dc7d83f8837470fba4187408c2b74f9?levelno=1&showmorebtn=true
// 
// var url='http://101.200.195.28/baoli/exhibitor-detail/';
window.addEventListener(
  'message',
  function(e) {
    console.log(e)
    if (!e.data.info) {
      return ''
    }
    if (e.data.info.id) {
      var el = document.createElement('a')
      document.body.appendChild(el)
      el.href = '/find-exhibitor/detail/'+e.data.info.id;
      el.target = '_blank' //指定在新窗口打开
      el.click()
      document.body.removeChild(el)
    }
    console.log('父页面....')
  },
  false
)
export default {
  name: 'mapPage',
  components: {},
  computed: {
    ...mapGetters(['subjectType']),
    mapUrl() {
      let floor = this.$route.params.floor || '1F'
      let url = ''
      if(floor === 'B1F') {
        url = 'https://nav.px-bim.com/viewer2/0dc7d83f8837470fba4187408c2b74f9?levelno=-1&showmorebtn=true'
      }
      if(floor === '1F') {
        url = 'https://nav.px-bim.com/viewer2/0dc7d83f8837470fba4187408c2b74f9?levelno=1&showmorebtn=true'
      }
      if(floor === '2F') {
        url = 'https://nav.px-bim.com/viewer2/0dc7d83f8837470fba4187408c2b74f9?levelno=2&showmorebtn=true'
      }
      if(floor === 'M2') {
        url = 'https://nav.px-bim.com/viewer2/0dc7d83f8837470fba4187408c2b74f9?levelno=3&showmorebtn=true'
      }
      if(floor === '3F') {
        url = 'https://nav.px-bim.com/viewer2/0dc7d83f8837470fba4187408c2b74f9?levelno=4&showmorebtn=true'
      }
      if(floor === '7F') {
        url = 'https://nav.px-bim.com/viewer2/0dc7d83f8837470fba4187408c2b74f9?levelno=5&showmorebtn=true'
      }
      return url
    }
  },
  data() {
    return {
      // mapUrl: 'https://nav.px-bim.com/viewer2/0dc7d83f8837470fba4187408c2b74f9?levelno=1&machineId=2ieCfmI8LvB&showmorebtn=true'
      
    }
  },
  created() {
    if(this.subjectType == 'ACTOR') {
       this.mapUrl = 'https://nav.px-bim.com/viewer2/0dc7d83f8837470fba4187408c2b74f9?levelno=1&machineId=2ieCfmI8LvB'
    }
   
    if (!browser.webKit) {
      alert('请用谷歌浏览器打开此页面')
    }
  }
}
</script>
<style lang="stylus" scoped>
::-webkit-scrollbar {
  display: none;
}
iframe{
  width:100%;
  height:100vh;
}
#a{
  // display:none;
}
</style>
